import { Modal, Table, Spin, Empty, Button } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { Constant } from "../../../../config";

const PAGE_SIZE = 10;

class ChangeLogModal extends Component {
  state = {
    loading: false,
    dataSource: [],
    visibleCount: PAGE_SIZE,
  };

  columns = [
    {
      title: "Field",
      dataIndex: "field_name",
      key: "field_name",
    },
    {
      title: "Old Value",
      dataIndex: "old_value",
      key: "old_value",
    },
    {
      title: "New Value",
      dataIndex: "new_value",
      key: "new_value",
    },
    {
      title: "Changed By",
      dataIndex: "changed_by",
      key: "changed_by",
      render: (text) => (text ? `Admin #${text}` : "-"),
    },
    {
      title: "Timestamp",
      dataIndex: "created_at",
      key: "created_at",
    },
  ];

  fetchLogs = async () => {
    const { memberId } = this.props;
    if (!memberId) return;

    this.setState({ loading: true, visibleCount: PAGE_SIZE });

    const url = Constant.MEMBER_LOGS_API.replace("[id]", memberId);
    const options = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };

    let resp;
    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    if (resp && resp.data && !resp.data.error) {
      this.setState({ dataSource: resp.data.data || [], loading: false });
    } else {
      this.setState({ loading: false });
    }
  };

  componentDidMount() {
    this.fetchLogs();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.visible &&
      (prevProps.memberId !== this.props.memberId || !prevProps.visible)
    ) {
      this.fetchLogs();
    }
  }

  loadMore = () => {
    this.setState((prev) => ({ visibleCount: prev.visibleCount + PAGE_SIZE }));
  };

  render() {
    const { visible, onCancel } = this.props;
    const { loading, dataSource, visibleCount } = this.state;
    const visibleData = dataSource.slice(0, visibleCount);
    const hasMore = visibleCount < dataSource.length;

    return (
      <Modal
        title="Change History"
        visible={visible}
        onCancel={onCancel}
        footer={null}
        width={800}
      >
        <Spin spinning={loading}>
          {dataSource.length > 0 ? (
            <div>
              <Table
                columns={this.columns}
                dataSource={visibleData}
                rowKey="id"
                pagination={false}
                size="small"
              />
              {hasMore && (
                <div style={{ textAlign: "center", marginTop: 16 }}>
                  <Button onClick={this.loadMore}>
                    Load More ({dataSource.length - visibleCount} remaining)
                  </Button>
                </div>
              )}
            </div>
          ) : (
            !loading && <Empty description="No change history found" />
          )}
        </Spin>
      </Modal>
    );
  }
}

export default ChangeLogModal;



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/components/ChangeLogModal.js